import { useEffect, useState } from "react";
import { API_CONFIG } from "../config/api";

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const verifyLogin = async () => {
      try {
        setIsAuthenticated(null);
        
        const response = await fetch(`${API_CONFIG.AUTH_URL}/verify`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          }
        });
        setIsAuthenticated(response.ok);
      } catch (error) {
        console.error("Erro ao verificar autenticação", error);
        setIsAuthenticated(false);
      }
    };

    verifyLogin();

    const checkLogoutInterval = setInterval(() => {
      if (localStorage.getItem('logoutEvent')) {
        localStorage.removeItem('logoutEvent');
        setIsAuthenticated(false);
      }
    }, 500);

    return () => {
      clearInterval(checkLogoutInterval);
    };
  }, []);

  return { isAuthenticated };
};

export default useAuth;